__turbopack_context__.v({
  "applyBtnWrapper": "header-opt-module-scss-module___IZodq__applyBtnWrapper",
  "applyNowBtn": "header-opt-module-scss-module___IZodq__applyNowBtn",
  "callIcon": "header-opt-module-scss-module___IZodq__callIcon",
  "callText": "header-opt-module-scss-module___IZodq__callText",
  "dCallButtonWrapper": "header-opt-module-scss-module___IZodq__dCallButtonWrapper",
  "dStudentLogin": "header-opt-module-scss-module___IZodq__dStudentLogin",
  "desktopHeaderBtnWrapper": "header-opt-module-scss-module___IZodq__desktopHeaderBtnWrapper",
  "enquireNowBtn": "header-opt-module-scss-module___IZodq__enquireNowBtn",
  "header": "header-opt-module-scss-module___IZodq__header",
  "headerBtnWrapper": "header-opt-module-scss-module___IZodq__headerBtnWrapper",
  "headerLogo": "header-opt-module-scss-module___IZodq__headerLogo",
  "headerWrapper": "header-opt-module-scss-module___IZodq__headerWrapper",
  "homeSearchResults": "header-opt-module-scss-module___IZodq__homeSearchResults",
  "homeSearchWrapper": "header-opt-module-scss-module___IZodq__homeSearchWrapper",
  "loginBtnWrapper": "header-opt-module-scss-module___IZodq__loginBtnWrapper",
  "menuToggleBtn": "header-opt-module-scss-module___IZodq__menuToggleBtn",
  "open": "header-opt-module-scss-module___IZodq__open",
  "sticky": "header-opt-module-scss-module___IZodq__sticky",
});
